// Widgets
// import Head2Head from "@components/Widgets/Head2Head";
import PlayingXi from "@components/Widgets/PlayingXi/PlayingXi";
import VenueStats from "@components/Widgets/VenueStats/VenueStats";
import SquadWidget from "@components/Widgets/Squad/Squad";
import AvgScores from "@components/Widgets/AvgScores/AvgScores";
import MatchLiveScoreWidget from "@components/Widgets/LiveScore";
import LastMatchesDetailWidget from "@components/Widgets/LastTenMatches";
import CommentaryWidget from "@components/Widgets/Commentary/Commentary";
import ScoreboardWidget from "@components/Widgets/Scoreboard/Scoreboard";
import PlayerOfTheMatch from "@components/Widgets/PlayerOfTheMatch/PlayerOfTheMatch";
import BestPlayerSummary from "@components/Widgets/BestPlayerSummary/BestPlayerSummary";
import TossAnalysisGraph from "@components/Widgets/TossAnalysisGraph/TossAnalysisGraph";
import OverWiseBreakdown from "@components/Widgets/OverWiseGraph/OverWiseGraph";
import LastTenWidgetGraph from "@components/Widgets/LastTenMatchGraph/LastTenMatchGraph";
// import MatchSummaryWidgetGroup from "@components/Widgets/MatchSummaryWidgetGroup";
import LiveScoreboardWidget from "@components/Widgets/LiveScoreboard/LiveScoreboard";
import ScoreProgressionGraph from "@components/Widgets/ScoreProgressionGraph/ScoreProgressionGraph";
import RunRateComparisonGraph from "@components/Widgets/RunrateComparisionGraph/RunrateComparisionGraph";
import PlayerLastFiveMatches from "@components/Widgets/LastFiveMatches/LastFiveMatches";
import PlayerCard from "@components/Widgets/PlayerInfo/PlayerInfo";
import PointsTable from "@components/Widgets/PointsTable/PointsTable";
import PlayerBattingCareerSummary from "@components/Widgets/PlayerBattingCareerSummary/PlayerBattingCareerSummary";
import PlayerBowlingCareerSummary from "@components/Widgets/PlayerBowlingCareerSummary/PlayerBowlingCareerSummary";
import KeyPlayerToWatch from "@components/Widgets/KeyPlayerToWatch/KeyPlayerToWatch";
import MatchSummaryGroup from "@components/Widgets/MatchSummaryGroup/MatchSummaryGroup";
import TagGroup from "@components/Widgets/TagGroup/TagGroup";
import PitchCardsGroup from "@components/Widgets/PitchCardsGroup/PitchCardsGroup";
import GenericAdvancedWidget from "@components/Widgets/LeaderBoard/Leaderboard";
import PlayerOfTheSeries from "@components/Widgets/PlayerOfTheSeries/PlayerOfTheSeries";
import Partnership from "@components/Widgets/Partnership";
import DebutLastMatches from "@components/Widgets/DebutLastMatches/DebutLastMatches";

const genericAdvancedWidgetKeys: string[] = [
    "sport_cricket_series_key_batsmen",
    "sport_cricket_series_highest_individual_score_batsmen",
    "sport_cricket_series_key_bowlers",
    "sport_cricket_series_best_strike_rate_batsmen",
    "sport_cricket_series_best_batting_averages_batsmen",
    "sport_cricket_series_most_hundreds_batsmen",
    "sport_cricket_series_most_fifties_batsmen",
    "sport_cricket_series_most_maiden_bowler",
    "sport_cricket_series_best_economy_bowler",
    "sport_cricket_series_best_strike_rate_bowler",
    "sport_cricket_series_most_five_wickets_bowler",
    "sport_cricket_series_most_four_wickets_bowler",
    "sport_cricket_series_best_bowling_figures_bowler",
    "sport_cricket_series_most_dismissals_keeper",
    "sport_cricket_series_most_dismissals_in_match_keeper",
    "sport_cricket_series_most_catches_fielder",
    "sport_cricket_series_most_catches_in_match_fielder",
];

const genericWidgetsMap: Record<string, any> = Object.fromEntries(
    genericAdvancedWidgetKeys.map((key) => [key, GenericAdvancedWidget]),
);

// Define the widget mapping
const widgetMap: Record<string, any> = {
    sport_cricket_match_top_players: BestPlayerSummary,
    sport_cricket_match_venue_weather_details: TagGroup,
    sport_cricket_match_live_score: MatchLiveScoreWidget,
    sport_cricket_match_live_partnership_fow_stats: MatchSummaryGroup,
    sport_cricket_match_latest_player_stats: LiveScoreboardWidget,
    sport_cricket_match_ball_by_ball: CommentaryWidget,
    sport_cricket_match_player_of_the_match: PlayerOfTheMatch,
    sport_cricket_match_player_of_the_series: PlayerOfTheSeries,
    sport_cricket_match_team_partnership_stats: Partnership,
    sport_cricket_match_key_players: KeyPlayerToWatch,
    sport_cricket_match_teams_last_10_matches_winners: LastMatchesDetailWidget,
    sport_cricket_match_teams_last_10_matches_runs: LastTenWidgetGraph,
    // sport_cricket_match_teams_last_10_matches_h2h: Head2Head,
    sport_cricket_match_pitch_details: PitchCardsGroup,
    sport_cricket_match_venue_stats: VenueStats,
    sport_cricket_player_last_five_match_stats: PlayerLastFiveMatches,
    sport_cricket_player_batting_career_summary: PlayerBattingCareerSummary,
    sport_cricket_player_bowling_career_summary: PlayerBowlingCareerSummary,
    sport_cricket_player_info: PlayerCard,
    sport_cricket_series_team_points_table: PointsTable,
    sport_cricket_series_teams_players_squad: SquadWidget,
    sport_cricket_match_scoreboard: ScoreboardWidget,
    sport_cricket_match_team_over_stats_overwise_breakdown: OverWiseBreakdown,
    sport_cricket_match_team_over_stats_runrate_comparison:
        RunRateComparisonGraph,
    sport_cricket_match_team_over_stats_score_progression:
        ScoreProgressionGraph,
    sport_cricket_match_players_squad: PlayingXi,
    sport_cricket_match_playing_eleven: PlayingXi,
    sport_cricket_match_venue_average_scores: AvgScores,
    sport_cricket_match_venue_toss_analysis: TossAnalysisGraph,
    sport_cricket_player_debut_last_match_stats: DebutLastMatches,
    ...genericWidgetsMap,
};

export default widgetMap;
